<template>
  <div class="flex gap-2 flex-col sm:flex-row">
    <USkeleton class="w-full sm:w-10/12 h-48 rounded-2xl" />
    <div class="flex flex-col gap-2 py-2 w-full justify-between">
      <div class="flex flex-col gap-2">
        <USkeleton class="w-5/12 sm:w-5/12 h-6 rounded-full" />
        <USkeleton class="w-10/12 sm:w-9/12 h-6 sm:h-8 rounded-full" />
      </div>
      <div class="grid grid-cols-3 gap-3">
        <USkeleton v-for="i in 3" class="w-full h-14 rounded-2xl" />
      </div>
    </div>
  </div>
</template>